import React from 'react';
import ConnectedModal from 'containers/ConnectedModal';
import CancellationLossAversionModalContents from './CancellationLossAversionModalContents';

export interface CancellationLossAversionModalProps {}

const CancellationLossAversionModal: React.FC<CancellationLossAversionModalProps> = () => {
  return (
    <ConnectedModal name="CancellationLossAversion" title="Cancel my plan">
      <CancellationLossAversionModalContents />
    </ConnectedModal>
  );
};

export default CancellationLossAversionModal;
